<template>
  <div class="m-access-denied">
    <h1>{{ $t('mAccessDenied.title.first') }}</h1>
    <h3>{{ $t('mAccessDenied.title.second') }}</h3>
    <a
      class="text-color-academy-primary text-weight-bold"
      href="#"
      @click.prevent="$router.go(-1)"
    >
      {{ $t('mAccessDenied.link') }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'MoleculeAccessDenied'
}
</script>
